import { render, staticRenderFns } from "./purchaseSaleStoreDetail.vue?vue&type=template&id=386a43de&scoped=true"
import script from "./purchaseSaleStoreDetail.vue?vue&type=script&lang=js"
export * from "./purchaseSaleStoreDetail.vue?vue&type=script&lang=js"
import style0 from "./purchaseSaleStoreDetail.vue?vue&type=style&index=0&id=386a43de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386a43de",
  null
  
)

export default component.exports